const DEFAULT_VISIBLE = 4;

/** Expert pill sizes match ExpertCard portrait widths */
const COMPACT_SLOT_CLASS =
  'w-[205px] shrink-0 snap-start sm:w-[230px] lg:w-[260px] xl:w-[285px]';

/** Free course card width */
const CARD_SLOT_CLASS = 'w-full sm:w-[260px] shrink-0 snap-start lg:w-[248px] xl:w-[288px]';

function HomeCarouselRow({
  items,
  renderItem,
  className = '',
  scrollRef,
  onScroll,
  visibleCount = DEFAULT_VISIBLE,
  layout = 'equal',
}) {
  if (!items?.length) return null;

  const isCompact = layout === 'compact';
  const isCards = layout === 'cards';
  const needsScroll = isCompact
    ? items.length > 1
    : isCards
      ? items.length > 3
      : items.length > visibleCount;
  const gapClass = isCompact || isCards ? 'gap-5' : 'gap-6';

  if (layout === 'cards') {
    return (
      <div
        ref={scrollRef}
        onScroll={onScroll}
        className={`w-full ${needsScroll ? 'overflow-x-auto snap-x snap-mandatory' : ''} pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}
      >
        <div className={`grid grid-cols-1 sm:flex ${needsScroll ? 'w-max' : 'justify-center'} ${gapClass}`}>
          {items.map((item, index) => (
            <div key={`${item.id ?? 'item'}-${index}`} className={CARD_SLOT_CLASS}>
              {renderItem(item, index)}
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (isCompact) {
    return (
      <div
        ref={scrollRef}
        onScroll={onScroll}
        className={`w-full min-w-0 ${needsScroll ? 'overflow-x-auto snap-x snap-mandatory' : ''} pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}
      >
        <div className={`flex ${needsScroll ? 'w-max' : 'justify-center'} ${gapClass}`}>
          {items.map((item, index) => (
            <div key={`${item.id ?? 'item'}-${index}`} className={COMPACT_SLOT_CLASS}>
              {renderItem(item, index)}
            </div>
          ))}
        </div>
      </div>
    );
  }

  const gaps = visibleCount - 1;
  const slideWidth = `calc((100cqw - ${gaps * 1.5}rem) / ${visibleCount})`;

  if (!needsScroll) {
    return (
      <div className={`grid w-full grid-cols-4 ${gapClass} ${className}`}>
        {items.map((item, index) => (
          <div key={`${item.id ?? 'item'}-${index}`} className="min-w-0">
            {renderItem(item, index)}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      ref={scrollRef}
      className={`w-full overflow-x-auto pb-2 [container-type:inline-size] [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}
    >
      <div className={`flex w-max ${gapClass}`}>
        {items.map((item, index) => (
          <div
            key={`${item.id ?? 'item'}-${index}`}
            className="shrink-0"
            style={{ width: slideWidth }}
          >
            {renderItem(item, index)}
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomeCarouselRow;
